import { z } from 'zod';

// ── Request (multipart/form-data payload) ───────────────────
export const UploadTransferProofSchema = z.object({
  transfer_proof: z.instanceof(File, {
    message: 'Bukti transfer harus berupa file!',
  }),
});

export type UploadTransferProofPayload = z.infer<
  typeof UploadTransferProofSchema
>;

export function toUploadTransferProofFormData(
  payload: UploadTransferProofPayload
): FormData {
  const formData = new FormData();

  formData.append('transfer_proof', payload.transfer_proof);

  return formData;
}

// ── Response (API shape → transform to DTO) ─────────────
const UploadTransferProofApiSchema = z
  .object({
    result: z.object({
      message: z.string().optional(),
      data: z.object({
        id_withdrawal: z.number(),
        transfer_proof: z.string().nullable(),
      }),
    }),
  })
  .transform(raw => ({
    idWithdrawal: raw.result.data.id_withdrawal,
    transferProof: raw.result.data.transfer_proof,
  }));

export type UploadTransferProofDTO = z.infer<
  typeof UploadTransferProofApiSchema
>;

export function toUploadTransferProofDTO(raw: unknown): UploadTransferProofDTO {
  return UploadTransferProofApiSchema.parse(raw);
}
